<template>
  <div id="code-template" class="code-template-space">
    <b-tabs>
      <b-tab active>
        <template #title>
          <div class="tab-wrp">
            <span class="">โค้ด</span>
          </div>
        </template>
        <div
          class="
            bar-code-wrp
            d-flex
            justify-content-center
            p-relative
            flex-column
            align-items-center
          "
        >
          <div class="p-absolute text-exemple-code">ตัวอย่างโค้ด</div>
          <div class="code">5H8UDC9AS</div>
          <div class="d-flex justify-content-center">
            <div
              class="btn-copy-code"
              :style="{ backgroundColor: resolveColor }"
            >
              <div class="text-copy-code">คัดลอก</div>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab>
        <template #title>
          <div class="tab-wrp">
            <bar-code-icon class="icon-bar-code" />
          </div>
        </template>
        <div
          class="
            bar-code-wrp
            d-flex
            justify-content-center
            p-relative
            flex-column
            align-items-center
          "
        >
          <div class="p-absolute text-exemple">ตัวอย่างโค้ด</div>
          <bar-code-icon width="100" height="80" />
          <div class="code-custom">5H8UDC9AS</div>
        </div>
      </b-tab>
      <b-tab>
        <template #title>
          <div class="tab-wrp">
            <q-icon-svg class="icon-qr-code" />
          </div>
        </template>
        <div
          class="
            qr-code-wrp
            d-flex
            justify-content-center
            p-relative
            flex-column
            align-items-center
          "
        >
          <div class="p-absolute text-exemple">ตัวอย่างโค้ด</div>
          <q-icon-svg width="80" height="80" />
          <div class="code-custom">5H8UDC9AS</div>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  onBeforeMount,
  onMounted,
  reactive,
  ref,
  computed,
  watch,
} from "@vue/composition-api";
import QIconSvg from "@/@core/components/svg/code-template/QRCodeIcon.vue";
import BarCodeIcon from "@/@core/components/svg/code-template/BarCodeIcon.vue";
import ImgQRCode from "@/assets/images/icons/ImgQRCode.png";
import ImgBarCode from "@/assets/images/icons/ImgBarcode.png";

import BarCodeIconSVG from "@/@core/components/svg/code-template/BarcodeExIcon.vue";
import QRCodeIconSVG from "@/@core/components/svg/code-template/QRCodeExIcon.vue";
import CodeNumIconSVG from "@/@core/components/svg/code-template/CodeNumExIcon.vue";

export default {
  props: {
    formModal: { type: [String, Object, Array], default: "" },
    codeColor: { type: String, default: "" },
    codeTextColor: { type: String, default: "" },
  },
  components: {
    QIconSvg,
    BarCodeIcon,
    BarCodeIconSVG,
    QRCodeIconSVG,
    CodeNumIconSVG,
  },
  setup(props) {
    const resolveColor = computed(() => {
      if (props.codeColor) return props.codeColor;
      else return "#000000";
    });

    const resolveTextColor = computed(() => {
      if (props.codeTextColor) return props.codeTextColor;
      else return "#ffffff";
    });

    const setBgCodeColor = () => {
      let root = document.querySelector(":root");
      if (props.codeColor)
        root.style.setProperty("--code-temp-bg", props.codeColor);
      else root.style.setProperty("--code-temp-bg", "#000000");
    };

    const setTextCodeColor = () => {
      let root = document.querySelector(":root");
      if (props.codeTextColor)
        root.style.setProperty("--code-temp-text", props.codeTextColor);
      else root.style.setProperty("--code-temp-text", "#ffffff");
    };

    onBeforeMount(() => {
      setBgCodeColor();
      setTextCodeColor();
    });

    watch(props, () => {
      setBgCodeColor();
      setTextCodeColor();
    });

    return {
      ImgQRCode,
      ImgBarCode,
      resolveColor,
      resolveTextColor,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/privilege/privilege-code-template/qr-code-template.css";

.code-custom {
  text-align: center;
  font-size: 16px;
}
</style>
